import * as Yup from 'yup';

export const partyIdentificationFields = (messages = {}) => {
  const m = messages;

  return {
    party_identification_id: Yup.string()
      .nullable()
      .when('party_identification_scheme_id', ([scheme], schema) => {
        if (scheme?.code != null && scheme?.code !== '') {
          return schema.required(
            m.party_identification_id_required ||
              'Party Identification is required when Party Identification Scheme is provided',
          );
        }

        return schema.notRequired();
      }),
    party_identification_scheme_id: Yup.mixed().nullable(),
  };
};
